/**
 * Date helpers for the admin analytics dashboard (#24).
 *
 * The dashboard's date inputs are controlled `YYYY-MM-DD` strings — that's
 * the wire shape the API expects, and HTML `<input type="date">` returns
 * the same format. Centralising format helpers here keeps the page
 * component readable.
 */

/** Format a `Date` as `YYYY-MM-DD` (UTC). */
export function formatDateInput(date: Date): string {
  const y = date.getUTCFullYear();
  const m = String(date.getUTCMonth() + 1).padStart(2, "0");
  const d = String(date.getUTCDate()).padStart(2, "0");
  return `${y}-${m}-${d}`;
}

/**
 * Compute the default range — the last 30 days ending today (UTC). The
 * `to` bound is today; `from` is 29 days earlier so the range is exactly
 * 30 calendar days inclusive of both ends.
 */
export function defaultDateRange(now: Date = new Date()): { from: string; to: string } {
  const today = new Date(
    Date.UTC(now.getUTCFullYear(), now.getUTCMonth(), now.getUTCDate(), 0, 0, 0, 0),
  );
  const fromDate = new Date(today.getTime() - 29 * 24 * 60 * 60 * 1000);
  return {
    from: formatDateInput(fromDate),
    to: formatDateInput(today),
  };
}
